import { createFileRoute, Outlet } from "@tanstack/react-router"

import ErrorComponent from "@/globalComponents/organisms/ErrorComponent"

export const Route = createFileRoute("/qr/$qrLookupID/gated/$pamID")({
  component: Outlet,
  errorComponent: (opts) => (
    <ErrorComponent {...opts} resolution="restartViaPAM" />
  ),
})
